import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/AuthContext";
import { Loader2, Lock, ArrowLeft } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      toast.success("Accesso effettuato");
      const dest = location.state?.from || "/admin";
      navigate(dest, { replace: true });
    } catch (err) {
      const detail = err?.response?.data?.detail;
      const msg = typeof detail === "string" ? detail : "Accesso non riuscito";
      setError(msg);
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-[#05050A] text-slate-100 flex items-center justify-center px-6">
      <div className="pointer-events-none fixed inset-0 -z-10 opacity-70"
        style={{ background: "radial-gradient(50% 40% at 20% 20%, rgba(147,51,234,0.2) 0%, transparent 60%), radial-gradient(50% 40% at 80% 80%, rgba(59,130,246,0.18) 0%, transparent 60%)" }}
      />
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 text-slate-400 hover:text-white transition text-sm mb-8">
          <ArrowLeft size={16} /> Torna al sito
        </Link>
        <div className="glass gradient-border rounded-3xl p-8 md:p-10">
          <div className="flex items-center gap-3 mb-6">
            <img src="/assets/logo.png" alt="Social Whale" className="h-10 w-10 object-contain drop-shadow-[0_0_18px_rgba(147,51,234,0.55)]" />
            <div>
              <div className="font-display text-white text-xl">Social<span className="text-gradient">Whale</span></div>
              <div className="text-xs uppercase tracking-widest text-purple-300/80">Area riservata</div>
            </div>
          </div>
          <h1 className="font-display text-3xl text-white leading-tight">Accedi al pannello lead</h1>
          <p className="mt-2 text-sm text-slate-400">Consulta e gestisci le richieste raccolte dal sito.</p>

          <form onSubmit={submit} className="mt-8 space-y-4" data-testid="admin-login-form">
            <div>
              <label htmlFor="admin-email" className="text-xs uppercase tracking-widest text-slate-400">Email</label>
              <input
                id="admin-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="admin-login-email"
                className="mt-2 w-full bg-white/[0.03] border border-white/10 rounded-xl px-4 py-3.5 text-white placeholder:text-slate-500 focus:border-purple-400/50 outline-none transition"
                placeholder="admin@socialwhale.it"
              />
            </div>
            <div>
              <label htmlFor="admin-password" className="text-xs uppercase tracking-widest text-slate-400">Password</label>
              <input
                id="admin-password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="admin-login-password"
                className="mt-2 w-full bg-white/[0.03] border border-white/10 rounded-xl px-4 py-3.5 text-white placeholder:text-slate-500 focus:border-purple-400/50 outline-none transition"
                placeholder="••••••••"
              />
            </div>
            {error && <div className="text-sm text-red-400" data-testid="admin-login-error">{error}</div>}
            <button
              type="submit"
              disabled={loading}
              data-testid="admin-login-submit"
              className="btn-primary w-full justify-center disabled:opacity-70 disabled:cursor-not-allowed"
            >
              {loading ? <Loader2 className="animate-spin" size={16} /> : <Lock size={16} />}
              {loading ? "Accesso…" : "Accedi"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
